/* Gleva · Direction B · gvb-stories.js — the home story hero (port of final-b2/_src/home.js "01 stories hero").
   Plays ONE cycle (data-seconds a story), then returns to story 1 and stops (data-one-cycle).
   Pauses: the pause button, press-and-hold, mouse hover, a hidden tab, or the hero leaving the screen.
   prefers-reduced-motion or data-no-autoplay: static story 1, Play button only.
   Poster-first: stories 2+ keep data-src until their turn (one story ahead) or until the page is idle. */
import { G } from 'gvb';

const $ = (s, r) => (r || document).querySelector(s);
const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));

function hydrate(story) {
  if (!story) return;
  $$('img,source', story).forEach((el) => {
    if (el.dataset.srcset) { el.srcset = el.dataset.srcset; el.removeAttribute('data-srcset'); }
    if (el.dataset.src) { el.src = el.dataset.src; el.removeAttribute('data-src'); }
  });
}

function boot(hero) {
  if (!hero || hero._gvbStories) return;
  hero._gvbStories = true;
  const stories = $$('.story', hero), copies = $$('.story-copy', hero), bars = $$('.story-bar', hero), tabs = $$('.story-tabs .chip', hero);
  const toggle = $('[data-story-toggle]', hero), stage = $('.hero-stage', hero);
  if (!stories.length || !toggle || !stage) return;
  const oneCycle = hero.hasAttribute('data-one-cycle');
  let i = 0, state = 'playing';
  const last = stories.length - 1;
  const load = (n) => hydrate(stories[(n + stories.length) % stories.length]);

  const setState = (st) => {
    state = st;
    hero.classList.toggle('is-paused', st !== 'playing');
    hero.classList.toggle('is-static', st === 'stopped');
    toggle.setAttribute('aria-label', st === 'playing' ? 'Pause stories' : 'Play stories');
  };
  const show = (n) => {
    i = (n + stories.length) % stories.length;
    load(i); load(i + 1);
    stories.forEach((s, k) => { const on = k === i; s.classList.toggle('is-active', on); s.setAttribute('aria-hidden', on ? 'false' : 'true'); });
    copies.forEach((c, k) => { const on = k === i; c.classList.toggle('is-active', on); c.setAttribute('aria-hidden', on ? 'false' : 'true'); c.inert = !on; });
    bars.forEach((b, k) => {
      b.classList.toggle('is-done', k < i);
      b.classList.toggle('is-active', k === i);
      b.setAttribute('aria-selected', k === i ? 'true' : 'false');
      const f = $('i', b);
      if (f) { f.style.animation = 'none'; void f.offsetWidth; f.style.animation = ''; }
    });
    tabs.forEach((t, k) => t.setAttribute('aria-pressed', k === i ? 'true' : 'false'));
  };
  /* manual navigation keeps playing if playing; otherwise browse statically */
  const go = (n) => { if (state === 'paused') setState('stopped'); show(n); };

  bars.forEach((b, k) => {
    const f = $('i', b);
    if (f) f.addEventListener('animationend', () => {
      if (!b.classList.contains('is-active') || state !== 'playing') return;
      if (i === last) { show(0); if (oneCycle) setState('stopped'); }
      else show(i + 1);
    });
    b.addEventListener('click', () => go(k));
  });
  tabs.forEach((t, k) => t.addEventListener('click', () => go(k)));
  const prev = $('.story-tap--prev', hero), next = $('.story-tap--next', hero);
  if (prev) prev.addEventListener('click', () => go(i - 1));
  if (next) next.addEventListener('click', () => go(i + 1));
  toggle.addEventListener('click', () => {
    if (state === 'playing') { setState('paused'); return; }
    setState('playing'); show(i);
  });
  if (G.reduce || hero.hasAttribute('data-no-autoplay')) setState('stopped');

  /* hold to pause, like Stories; swipe to change */
  let x0 = null, y0 = null;
  stage.addEventListener('pointerdown', (e) => { hero.classList.add('is-held'); x0 = e.clientX; y0 = e.clientY; });
  ['pointerup', 'pointercancel', 'pointerleave'].forEach((ev) => {
    stage.addEventListener(ev, (e) => {
      hero.classList.remove('is-held');
      if (ev === 'pointerup' && x0 !== null) {
        const dx = e.clientX - x0, dy = e.clientY - y0;
        if (Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy) * 1.4) go(dx < 0 ? i + 1 : i - 1);
      }
      x0 = null;
    });
  });
  if (window.matchMedia('(hover:hover)').matches) {
    stage.addEventListener('mouseenter', () => hero.classList.add('is-held'));
    stage.addEventListener('mouseleave', () => hero.classList.remove('is-held'));
  }
  document.addEventListener('visibilitychange', () => hero.classList.toggle('is-held', document.hidden));
  if ('IntersectionObserver' in window) {
    new IntersectionObserver((es) => hero.classList.toggle('is-off', !es[0].isIntersecting), { threshold: 0.4 }).observe(stage);
  }
  hero.addEventListener('keydown', (e) => {
    if (e.target.closest('.story-copy a')) return;
    if (e.key === 'ArrowRight') go(i + 1);
    if (e.key === 'ArrowLeft') go(i - 1);
  });
  /* the rest of the stories load once the page is idle */
  const idle = window.requestIdleCallback || ((f) => setTimeout(f, 1200));
  const loadAll = () => idle(() => stories.forEach((s, k) => load(k)));
  if (document.readyState === 'complete') loadAll(); else window.addEventListener('load', loadAll);
  hero._gvb = { show, setState, state: () => state, index: () => i };
}

const init = (scope) => $$('[data-stories]', scope).forEach(boot);
init(document);
document.addEventListener('shopify:section:load', (e) => init(e.target));
document.addEventListener('shopify:block:select', (e) => {
  const hero = e.target.closest && e.target.closest('[data-stories]');
  if (!hero || !hero._gvb) return;
  const k = Array.from(hero.querySelectorAll('.story')).indexOf(e.target);
  if (k >= 0) { hero._gvb.setState('stopped'); hero._gvb.show(k); }
});
